import React, { useState } from "react";
import styles from "./Services2.module.scss";
import useHover from "../../../utilities/useHover";
import Layout from "../../layouts/Layout/Layout";
import { Link } from "../../elements";
import THEME from "../../../state/theme";
import Accordion from '../Teams/Accordion';
import CoreTeam from '../Teams/CoreTeam';


export default () => {

  return (
    <>
      <div className={styles.maindiv}>
        <div className="layout-header">
          <span className={styles.subtitle} >
            <p>MEET THE CORE TEAM</p>

          </span>
        </div>
        <CoreTeam />
        <Accordion />
      </div>
    </>
  );
};